import AdminProfile from './AdminProfile';
export default AdminProfile;
